module.exports = __webpack_public_path__ + "static/media/vaishnavi_shelar.d4edfb01.png";